"use strict";
export default React.createClass({
  propsTypes: {
    onClick: React.PropTypes.func.isRequired
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("button", { className: "button--link-v2 button-small mb-0", onClick: this.props.onClick }, this.props.children);
  }
});
